import styled from 'styled-components';
import color from '../../../config/colors.json';

export const Title = styled.h1`
    font-family: 'Poppins', sans-serif;
    font-size: 31px;
    line-height: 44px;
    text-align: center;
    color: ${color.softDark};
`;

export const Text = styled.em`
    font-style: normal;
    font-size: 22px;
    line-height: 31px;
    text-align: center;
    color: ${color.lightGrey21};
    display: block;
`;
